let currentLocale = 'en';

export const setGlobalLocale = (code) => {
  if (typeof code === 'string' && code.trim()) {
    currentLocale = code;
  }
};

export const getGlobalLocale = () => currentLocale;
